import { accessOptions } from '@/domain/global.enum';

const menu = [
  {
    header: 'Apps',
    group: 'apps',
    options: [accessOptions.DASHBOARD],
    divider: true,
  },
  {
    header: 'Monitor',
    group: 'monitor',
    existItems: true,
    options: [accessOptions.MONITOR],
  },
];

export default menu;
